import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../hooks';
import { Link } from 'react-router-dom';
import {
  TopBarContainer,
  SideNavContainer,
  BreadcrumbContainer,
} from '../../../components/Dashboard';

import {
  Layout,
  PageNavContainer,
  MainContainer,
  PageNavLeftContainer,
  PageNavRightContainer,
} from './Styles';
// import MemberStatusFilter from '../../../components/Dashboard/MemberStatusFilter';
import MembersHome from '../../../components/Dashboard/Members/MembersHome';
import { dashboardBreadcrumb } from '../../../data/routes';

const AdminLayout = ({
  AuctionID,
  auctionName,
  laneName,
  memberType,
  breadcrumbLocation,
}) => {
  const {
    AuthStore: { memberName },
    UIStore: { setHeaderText },
  } = useStores();

  // const [memberState, setMemberState] = useState('');
  // const onMemberStateChanged = (value) => setMemberState(value);

  const items = [
    dashboardBreadcrumb,
    { to: '/auctions', label: 'Auctions' },
    {
      label: breadcrumbLocation,
    },
  ];

  
  React.useEffect(() => {
    setHeaderText(auctionName);
  }, []);

  return (
    <Layout>
      <TopBarContainer
        // auctionAndLaneName={auctionName}
        // title={`Registered Members`}
        // laneName={`auctionLaneName`}
        memberName={memberName}
        showLogout
      />
      <SideNavContainer />
      <PageNavContainer>
        <PageNavLeftContainer>
          <BreadcrumbContainer items={items}>
            {items.map(({ to, label }) =>
              to ? (
                <Link key={to} to={to}>
                  {label}
                </Link>
              ) : (
                label
              ),
            )}
          </BreadcrumbContainer>
        </PageNavLeftContainer>

        <PageNavRightContainer>
          {/* {showMemberStatusFilter && (
            <MemberStatusFilter
              onStatusChange={onMemberStateChanged}
              title="Status"
            />
          )} */}
        </PageNavRightContainer>
      </PageNavContainer>
      <MainContainer>
        <MembersHome
          // key={memberState}
          laneName={laneName}
          auctionName={auctionName}
          AuctionID={AuctionID}
          memberType={memberType}
          // memberState={memberState}
          // showMemberStatusFilter={showMemberStatusFilter}
          // filterComponents={
          //   <div>
          //     <MemberStateContainer
          //       onMemberStateChanged={onMemberStateChanged}
          //       title="Status:"
          //       memberState={memberState}
          //     />
          //   </div>
          // }
        />
      </MainContainer>
    </Layout>
  );
};

export default observer(AdminLayout);
